import {DocHolder} from "lib/edit/docHolder";
import {XmlTypedHouse} from "lib/edit/ot/xmlTypedHouse";
import {EventsMgr, IEventsMgr} from "lib/commons/events";
import {XmlBatch} from "lib/edit/ot/xmlHouse";
import {IMsgFilter, UndirtyMsgOt} from "lib/edit/ot/houseOt";
import {JSrcFields} from "lib/wsp/src";
import {ICollabLock, IPlaceDocHolder, IWspXmlHouse, IWspXmlHouseEvents, WspsLivePlace} from "lib/wsp/wspsLive";
import {House, IDoorBase, IReply, Msg, ODoorConfig, ResetStatesMsg, RoadEnd} from "lib/edit/ot/urban";
import {IWsExecFrame} from "lib/core/universe";
import {JWspWorkingState, Wsp, wspId, wspRef, wspUri} from "lib/wsp/wsp";
import {ItemType} from "lib/wsp/wspMetaUi";
import {IDocumentInWspHouse} from "back/wsp/widgets/wed/schemaMetaWsp";


export class PlaceDocHolder extends DocHolder implements IPlaceDocHolder {

	house: IWspXmlHouse;

	constructor(house: XmlTypedHouse, readonly place: WspsLivePlace) {
		super(house);
		place._docHolders.add(this);
		this.house.notUsedSince = 0;
	}

	// @ts-ignore
	houseLstn: IEventsMgr<IWspXmlHouseEvents>;

	cloneDocHolder(): PlaceDocHolder {
		return new PlaceDocHolder(this.house, this.place);
	}

	doBatch(batch: XmlBatch) {
		if (this.house.lockedBy == null) super.doBatch(batch);
		else console.warn("doBatch() called on PlaceDocHolder in locked state.");
	}

	willUndo(filter?: IMsgFilter): Promise<boolean> {
		if (this.house.lockedBy == null) return super.willUndo(filter);
		else console.warn("willUndo() called on PlaceDocHolder in locked state.");
		return Promise.resolve(false);
	}

	willRedo(filter?: IMsgFilter): Promise<boolean> {
		if (this.house.lockedBy == null) return super.willRedo(filter);
		else console.warn("willRedo() called on PlaceDocHolder in locked state.");
		return Promise.resolve(false);
	}

	close() {
		this.place._docHolders.delete(this);
		const house = this.house;
		super.close();
		if (house.publicDoors.length === 0) house.notUsedSince = Date.now();
	}

	save(): Promise<void> {
		return this.place.wspsLive._saveHouse(this.house, this.place);
	}
}

export class WspXmlHouse extends XmlTypedHouse implements IWspXmlHouse {
	listeners: EventsMgr<IWspXmlHouseEvents>
	id: wspRef
	wspUri: wspUri
	wspId?: wspId
	wspRef: wspRef;
	wspUriItem: wspUri
	wsp: Wsp
	itemType: ItemType
	srcFields: JSrcFields
	lockedBy?: ICollabLock
	states?: JWspWorkingState[]
	notUsedSince: number
	killed: boolean
	saveTimer?: number

	xInitDom(root: Node) {
		const doc = root as IDocumentInWspHouse;
		if (!doc.wsp) {
			doc.wsp = this.wsp;
			doc.srcRefMap = new Map();
		}
	}
}

export class WspXmlSlaveHouse extends WspXmlHouse {
	onMsg(msg: Msg, fromDoor: IDoorBase) {
		if (msg.type === UndirtyMsgOt.type) {
			const props = (msg as UndirtyMsgOt<JSrcFields>).props;
			if (props) Object.assign(this.srcFields, props); //mise à jour des champs srcDt, srcStamp...
		} else if (msg instanceof ResetStatesMsg && msg.datas.body === null) {
			//body null = suppression de la house / de l'item.
			this.wsp.wspServer.wspsLive._removeHouse(this);
			return;
		}
		super.onMsg(msg, fromDoor);
	}
}

export class RoadExecFrameWs extends RoadEnd {

	protected _ws: IWsExecFrame;
	protected _house: House;

	constructor(execFrame: IWsExecFrame, house: House) {
		super();
		this._ws = execFrame;
		this._house = house;
	}

	pushRequest<R extends IReply>(msg: Msg): Promise<R> {
		const m = msg.asJson() as JMoanClientMsg;
		m.houseId = this._house.id;
		m.svc = "moan";
		// m.repWId = ++this._counter; // Pas d'usage de repWId -> forId, Req/Rep géré par l'execFrame
		return this._ws.sendReq<R>(m);
		// const r = await this._ws.sendReq<R>(m);
		// r.forId = m.repWId;
		// return r;
	}

	xPushMsg(msg: Msg) {
		const m = msg.asJson() as JMoanClientMsg;
		m.houseId = this._house.id;
		m.svc = "moan";
		this._ws.sendMsg(m);
	}


	newRoadFor(house: House, config?: ODoorConfig): RoadEnd {
		return new RoadExecFrameWs(this._ws, house);
	}

	doorClosed() {
		this._ws.sendMsg(JSON.stringify({
			svc: 'moan',
			houseId: this._house.id,
			slaveClosed: true
		} as JMoanCloseClientMsg));
		this.door = null;
	}
}

interface JMoanClientMsg extends Msg {
	svc: 'moan'
	houseId: wspRef
}


interface JMoanCloseClientMsg extends JMoanClientMsg {
	slaveClosed: true
}
